import { render, staticRenderFns } from "./transaction-records.vue?vue&type=template&id=619a2a9c&scoped=true"
import script from "./transaction-records.vue?vue&type=script&lang=js"
export * from "./transaction-records.vue?vue&type=script&lang=js"
import style0 from "./transaction-records.vue?vue&type=style&index=0&id=619a2a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a2a9c",
  null
  
)

export default component.exports